import Vue from "vue";

import { create, all } from "mathjs";

import {
  Transfer,
  InputNumber,
  Switch,
  Autocomplete,
  Dialog,
  Upload,
  MessageBox,
  Notification,
  Loading,
  Button,
  ButtonGroup,
  Select,
  Form,
  Input,
  Alert,
  Steps,
  Step,
  Option,
  Pagination,
  DatePicker,
  Container,
  FormItem,
  Table,
  TableColumn,
  Header,
  Aside,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Main,
  Row,
  Col,
  Message,
  Tree,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxGroup,
  Tooltip,
  Popover,
  Tag,
  Radio,
  Carousel,
  CarouselItem,
  RadioGroup,
  RadioButton,
  Cascader,
  TimePicker,
  Progress,
  Badge,
  Image,
  Timeline,
  TimelineItem,
  Card,
  Descriptions,
  DescriptionsItem,
  Divider,
  Link,
} from "element-ui";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition.js"; // collapse动画
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/iconfont.css";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import VueCookie from "vue-cookie";
import qs from "qs";
import * as echarts from "echarts";
import VueClipboard from "vue-clipboard2";
// eslint-disable-next-line import/no-extraneous-dependencies
import Viewer from "v-viewer"; // 图片浏览
import "viewerjs/dist/viewer.css";
import App from "./App.vue";
import router from "./router/index.js";
import { cookieCacheGet } from "./tool/cache.js";
import YsUpload from "@/components/YsComponents/YsUpload.vue";
import YsInput from "@/components/YsForm/YsInput.vue";
import YsDataTable from "@/components/PageComponents/YsDataTable.vue";
import YsUploadCombo from "@/components/YsForm/YsUploadCombo.vue";
import api from "@/api/index.js";
import { errorLog, excalibur, $post, $removeSelf } from "./tool/helper.js";
import apiBaseURL from "@/utils/baseUrl.js";

/* 引入状态管理 */
import store from "./store/index.js";
// 注册全局的图片预览指令 <div v-viewImg=['a.jpg']></div>
import { previewImage } from "./tool/viewerImage.js";

// create a mathjs instance with configuration
const mathConfig = {
  number: "BigNumber", // 直接使用它的 api 还不能解决浮点精度问题，要使用BigNumber
};
const math = create(all, mathConfig);
const isEnvTest =
  process.env.NODE_ENV === "local" || window.location.href.indexOf("test") > -1;
const isProduction =
  (process.env.NODE_ENV === "production" ||
    process.env.NODE_ENV === "publish") &&
  !isEnvTest;

// #创建一个axios实例
const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  // #config里面有这个transformRquest，这个选项会在发送参数前进行处理。
  // #这时候我们通过Qs.stringify转换为表单查询参数
  transformRequest: [
    function transformRequest(data, headers) {
      if (headers["Content-Type"] === "application/json") {
        return JSON.stringify(data);
      }
      if (headers["Content-Type"] === "multipart/form-data") {
        return data;
      }
      return qs.stringify(data);
    },
  ],
  // #设置Content - Type
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
// @jiaminghi/data-view 这个库的导出模式与 vite 不兼容，会报错，试了很多方式仍未解决
// 目前该库项目中仅在业务监控下的监控面板中使用，而此业务已停用，因此暂不影响
// import dataV from "@jiaminghi/data-view";
// Vue.use(dataV);
Vue.use(VueClipboard);
Vue.use(VueRouter);
Vue.use(VueAxios, axiosInstance);
Vue.use(VueCookie);
Vue.use(Viewer);
Vue.use(Loading.directive);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Tree);
Vue.use(Image);
Vue.use(Autocomplete);
Vue.use(Switch);
Vue.use(InputNumber);
Vue.use(Transfer);
Vue.use(Popover);
Vue.use(Tag);
Vue.use(Radio);
Vue.use(TimePicker);
Vue.use(Progress);
Vue.use(Cascader);
Vue.use(Badge);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Card);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Divider);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$echarts = echarts;
Vue.prototype.$math = math; // 挂载到 vue 原型链在全局使用

// 重写错误提示
Message.error = (option) => {
  if (typeof option === "object") {
    Message(option);
  } else if (typeof option === "string") {
    Message({
      message: option,
      type: "error",
      duration: 0,
      showClose: true,
    });
  } else {
    Message({
      message: "未知的错误类型",
      type: "error",
      duration: 0,
      showClose: true,
    });
  }
};

// 会自动关闭且不会重叠的报错弹窗
let eCurrentContent = null;
Message.e = (msg) => {
  if (eCurrentContent) eCurrentContent.close();
  const _msg = msg || "操作错误";
  eCurrentContent = Message({
    message: _msg,
    type: "error",
    duration: 10000,
    showClose: true,
    onClose: () => {
      eCurrentContent = null;
    },
  });
};
Vue.prototype.$message = Message;
// element-ui的组件引入方式

Vue.component(CollapseTransition.name, CollapseTransition);
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);
Vue.component(Select.name, Select);
Vue.component(Input.name, Input);
Vue.component(Container.name, Container);
Vue.component(Header.name, Header);
Vue.component(Aside.name, Aside);
Vue.component(Menu.name, Menu);
Vue.component(Submenu.name, Submenu);
Vue.component(MenuItemGroup.name, MenuItemGroup);
Vue.component(MenuItem.name, MenuItem);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Main.name, Main);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Message.name, Message);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);

Vue.component(Option.name, Option);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Pagination.name, Pagination);
Vue.component(Steps.name, Steps);
Vue.component(Step.name, Step);
Vue.component(Alert.name, Alert);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Cascader.name, Cascader);
Vue.component(Link.name, Link);
Vue.component("YsDataTable", YsDataTable);
Vue.component("YsInput", YsInput);
Vue.component("YsUpload", YsUpload);
Vue.component("YsUploadCombo", YsUploadCombo);

Vue.prototype.$api = api;

Vue.config.productionTip = false;

axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof config.no_loading !== "undefined") {
      store.commit("SET_LOADING", !config.no_loading);
    } else {
      store.commit("SET_LOADING", true);
    }
    if (config.data instanceof FormData) {
      return config;
    }

    cookieCacheGet("deskNo");
    const newConfig = config;
    newConfig.data = {
      ...config.data,
      is_pc: 1,
    };
    // 只针对get方式进行序列化，为了兼容传数组的形式
    // if (config.method === "get") {
    //   config.paramsSerializer = function(params) {
    //     return qs.stringify(params, { arrayFormat: "repeat" });
    //   };
    // }
    return newConfig;
  },
  () => {
    store.commit("SET_LOADING", false);
  }
);

// 拦截请求返回数据，如果返回的code是401则删除token并跳转到login
axiosInstance.interceptors.response.use(
  (response) => {
    store.commit("SET_LOADING", false);

    const { data: responseData } = response;
    let { code } = responseData;
    // 此处兼容后端返回的二进制数据类型
    if (!code) {
      return response;
    }
    // 转一下code的数据类型
    code = parseInt(code, 10);
    switch (code) {
      case 201:
        // 登陆过期或者未登录 返回登陆页
        router.replace("/");
        return response;
      case 200:
        // 默认把reponse对象返回 兼容之前的代码
        return response;
      default:
        // Message({
        //   message: msg,
        //   type: "error",
        //   duration: 2 * 1000,
        // });
        return response;
    }
  },
  (error) => {
    console.log("🚀 : error", error);
    store.commit("SET_LOADING", false);
    const { status } = error.response;
    const newErr = error;
    switch (status) {
      case 400:
        newErr.message = "请求错误";
        break;
      case 401:
        newErr.message = "未授权，请登录";
        break;
      case 403:
        newErr.message = "拒绝访问";
        break;
      case 404:
        newErr.message = `请求地址出错: ${error.response.config.url}`;
        break;
      case 408:
        newErr.message = "请求超时";
        break;
      case 500:
        newErr.message = "服务器内部错误";
        break;
      case 501:
        newErr.message = "服务未实现";
        break;
      case 502:
        newErr.message = "网关错误";
        break;
      case 503:
        newErr.message = "服务不可用";
        break;
      case 504:
        newErr.message = "网关超时";
        break;
      case 505:
        newErr.message = "HTTP版本不受支持";
        break;
      default:
        newErr.message = "未知的错误";
        break;
    }
    errorLog(newErr);
    return Promise.reject(newErr);
  }
);
/* eslint-disable no-new */
Vue.directive("viewImg", {
  inserted: (el, binging) => {
    el.addEventListener("click", () => {
      const { value } = binging;
      previewImage(value);
    });
  },
});

Vue.prototype.$removeSelf = $removeSelf();

Vue.prototype.$excalibur = excalibur;

if (isProduction) {
  Vue.config.errorHandler = function errorHandler(error, vm, info) {
    console.error(error, vm, info);
  };
}
const vue = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
Vue.prototype.$post = $post(vue);
Vue.prototype.$noop = () => {};
Vue.prototype.$bus = new Vue();



// WEBPACK FOOTER //
// ./src/main.js